<template>
  <div>
    <div v-if="screenStrScope(value, mode) && screenStrScope(value, mode).name">
      {{title}} <span v-if="title">：</span>
      <span>
        {{screenStrScope(value, mode).name}}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    title: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: ''
    },
    month: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data () {
    return {

    }
  },
  methods: {
    screenStrScope (list, mode) {
      if (!list) {
        return
      }
      let obj = list.find(item => {
        return item.month === this.month.year + '-' + this.month.month
      })
      if (obj) {
        return obj.items.find(item => {
          return item.type === mode
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
